export default __webpack_public_path__ + "static/media/VendorNegotiationBG.0576201b.jpg";